import { Box } from '@mui/material';
import { FC } from 'react';
import SmoothLink from '../SmoothLink';

interface LogoProps {
  width?: number;
  height?: number;
}
const Logo: FC<LogoProps> = ({ width, height }) => {
  return (
    <SmoothLink
      to="/"
      style={{
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        component="img"
        src="/images/haist/haist-logo.png"
        alt="Logo"
        width={width ? width : { xs: 80, sm: 110 }}
        height={height ? height : { xs: 32, sm: 40 }}
        style={{ cursor: 'pointer', objectFit: 'contain' }}
      />
    </SmoothLink>
  );
};

export default Logo;
